import React, { Component } from 'react';
import { connect } from 'react-redux';
import DayPicker, { DateUtils } from 'react-day-picker';
import moment from 'moment';
import 'react-day-picker/lib/style.css';
import ToolTip from '../ui/ToolTip';
import { getNumberWithCommas } from '../../constants/util';

const mapStateToProps = state => ({
  user: state.Dashboard.user
});

class CalendarComponent extends Component {
  constructor(props) {
    super(props);
    this.currentMonthDiv = React.createRef();
    this.renderDayInner = this.renderDayInner.bind(this);

  }

  componentDidMount() {
    document.getElementsByClassName('calendar-container')[0].scrollTop = this.currentMonthDiv.current.offsetTop;
  }

  renderDayInner = (overrideDay, baseFee) => {
    if (overrideDay !== undefined) {
      if (overrideDay.availability === 'Available') {
        return this.renderOverrideDay(overrideDay.price);
      }
      return this.renderUnavailableDay()
    }

    return <div className="day-price"><span>${getNumberWithCommas(baseFee)}</span></div>
  }

  renderDay = (day) => {
    const date = day.getDate();
    let overrideDay;

    const { weekendFee } = this.props;

    if (this.props.modifiers.overrides) {
      let overrides = this.props.modifiers.overrides;
      overrideDay = overrides.find(o => DateUtils.isSameDay(new Date(o.date), day));
    }

    if (!!weekendFee && !!weekendFee.from && !!weekendFee.to) {
      const weekDay = day.getDay();
      if (moment(day).isBetween(moment(weekendFee.from), moment(weekendFee.to))
        && (weekDay === 5 || weekDay === 6)
      ) {
        overrideDay = {
          availability: 'Available',
          price: weekendFee.value
        }
      }
    }

    return (
      <div className="calendar-day">
        <div className="font-weight-bold day-date">{date}</div>
        {this.renderDayInner(overrideDay, this.props.baseFee)}
      </div>
    );

  }

  renderOverrideDay = (price) => {
    return (
      <div className="day-price"><span>${getNumberWithCommas(price)}</span></div>
    )
  }

  renderUnavailableDay = () => {
    return (
      <div className="day-price"><span>-</span></div>
    )
  }

  handleDayClick = (day, { selected, airbnb, vrbo, other, checkout, checkin, cwcheckout, cwcheckin }) => {
    if (this.props.className !== 'display-only') {
      if ((!airbnb && !vrbo && !other) || (checkout && !checkin && !cwcheckin) || (cwcheckout && !cwcheckin && !checkin)) {
        this.props.dateHandler(day, selected, this.props.modifiers);
      }
    }
  }

  render() {
    let now = new Date();
    let currentYear = now.getFullYear();
    let currentMonth = now.getMonth();

    const { from, to } = this.props;
    const modifiers = { from: from, to: to };

    return (<div>
      <div className="row">
        <ul className="col calendar-legend">
          <li><span className="available"></span> Available</li>
          <li><span className="cw"></span> College Weekends</li>
          <li><span className="synced"></span> 3rd Party<ToolTip position="top" message="Hover/tap the day to view which booking service has it reserved.">
            <i className="far fa-question-circle"></i></ToolTip></li>
          <li><span className="unavailable"></span> Blocked</li>
        </ul>
      </div>
      <div className="calendar-container" ref={this.calendarContainer} >
        <DayPicker
          className="Selectable"
          selectedDays={this.props.singleDay === true || this.props.singleDay === undefined ? this.props.selectedDaysParent : [from, { from, to }]}
          modifiers={this.props.singleDay === true ? null : modifiers}
          onDayClick={this.handleDayClick}
          numberOfMonths={31}
          initialMonth={new Date(currentYear - 1, currentMonth)}
          canChangeMonth={false}
          renderDay={this.renderDay}
          captionElement={({ date, localeUtils, locale }) => {
            return (
              <div className="DayPicker-Caption" role="heading"
                ref={date.getMonth() === currentMonth && date.getFullYear() === currentYear ? this.currentMonthDiv : null}>
                <div>{localeUtils.formatMonthTitle(date, locale)}</div>
              </div>
            )
          }}
          {...this.props}
        />
      </div>
    </div>);
  }
}

export default connect(mapStateToProps)(CalendarComponent);
